export default __webpack_public_path__ + "static/media/voicegot-screenshot-03.5b9baa53.png";